<template>
  <div class="group flex cursor-pointer items-center">
    <i v-if="!slots.default"
       :class="[`tr tr-${icon}`, ICON_STATE]"
       class="tr flex items-center"></i>
    <span class="tr flex items-center" :class="ICON_STATE" v-else>
      <slot ></slot>
    </span>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
})

const slots = useSlots()

const ICON_STATE = computed(() => (props.active
  ? 'text-accent opacity-100'
  : 'text-text opacity-30 group-hover:opacity-100'))
</script>
